<template>
  <footer class="transparent--bg white m0 pa3">
    <w-flex>
    <span class="box">&copy; 2021 - {{ new Date().getFullYear() }} 2en Apps Sdn Bhd</span>
    <span class="spacer"></span>
    <div class="box">
    <w-button @click="scrollToTop" icon="fal fa-angle-double-up">
    </w-button>
    </div>
    </w-flex>
  </footer>
</template>

<script>
export default {
  methods: { 
  scrollToTop() {
      window.scrollTo(0,0);
    }
  }
}
</script>

<style>


footer {
  min-height: 20px;
  margin-top: 0;
}


</style>